import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Home({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.3065 1.27951C11.6937 0.906829 12.3063 0.906829 12.6935 1.27951L22.6935 10.9045C22.8893 11.093 23 11.3532 23 11.625V22C23 22.5523 22.5523 23 22 23H15V21H21V12.0504L12 3.38795L3 12.0505V21H10V15H12V22C12 22.5523 11.5523 23 11 23H2C1.44772 23 1 22.5523 1 22V11.625C1 11.3532 1.11067 11.093 1.30653 10.9045L11.3065 1.27951Z"
        fill={iconColor}
      />
    </Svg>
  );
}
